export var DEFAULT_FIRST_DAY_OF_WEEK = 1;
// CLDR weekData (firstDay): territori con settimana che inizia di domenica, venerdì o sabato.
// Tutti gli altri territori (inclusa l'Europa) iniziano di lunedì.
var SUNDAY_FIRST_REGIONS = new Set([
    'AG',
    'AS',
    'BD',
    'BR',
    'BS',
    'BT',
    'BW',
    'BZ',
    'CA',
    'CO',
    'DM',
    'DO',
    'ET',
    'GT',
    'GU',
    'HK',
    'HN',
    'ID',
    'IL',
    'IN',
    'IS',
    'JM',
    'JP',
    'KE',
    'KH',
    'KR',
    'LA',
    'MH',
    'MM',
    'MO',
    'MT',
    'MX',
    'MZ',
    'NI',
    'NP',
    'PA',
    'PE',
    'PH',
    'PK',
    'PR',
    'PT',
    'PY',
    'SA',
    'SG',
    'SV',
    'TH',
    'TT',
    'TW',
    'UM',
    'US',
    'VE',
    'VI',
    'WS',
    'YE',
    'ZA',
    'ZW',
]);
var FRIDAY_FIRST_REGIONS = new Set(['MV']);
var SATURDAY_FIRST_REGIONS = new Set([
    'AF',
    'BH',
    'DJ',
    'DZ',
    'EG',
    'IQ',
    'IR',
    'JO',
    'KW',
    'LY',
    'OM',
    'QA',
    'SD',
    'SY',
]);
export var firstDayOfWeekForRegion = function (region) {
    var normalized = region === null || region === void 0 ? void 0 : region.toUpperCase();
    if (!normalized) {
        return DEFAULT_FIRST_DAY_OF_WEEK;
    }
    if (SUNDAY_FIRST_REGIONS.has(normalized)) {
        return 0;
    }
    if (FRIDAY_FIRST_REGIONS.has(normalized)) {
        return 5;
    }
    if (SATURDAY_FIRST_REGIONS.has(normalized)) {
        return 6;
    }
    return DEFAULT_FIRST_DAY_OF_WEEK;
};
export var getWeekDayOrder = function (firstDay) {
    return Array.from({ length: 7 }, function (_, i) { return ((firstDay + i) % 7); });
};
export var startOfWeek = function (date, firstDay) {
    return date.subtract((date.day() - firstDay + 7) % 7, 'day').startOf('day');
};
export var endOfWeek = function (date, firstDay) {
    return startOfWeek(date, firstDay).add(6, 'day').endOf('day');
};
// Intl.Locale weekInfo usa 1=lunedì..7=domenica; JS/dayjs usano 0=domenica..6=sabato.
export var fromWeekInfoDay = function (day) {
    return (day % 7);
};
